export const selectFetchingLocationsInProgress = (state) => state.globalLocationList.fetchingLocationsInProgress;
export const selectFetchingLocationsError = (state) => state.globalLocationList.fetchingLocationsError;
export const selectLocationsList = (state) => state.globalLocationList.locationsList;
export const selectSelectedLocationId = (state) => state.globalLocationList.selectedLocationId;
export const selectSelectedLocation = (state) => {
    return state.globalLocationList.locationsList.find((location) => location.id === state.globalLocationList.selectedLocationId);
};
